import styles from './style.postcss';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import is from 'is_js';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import {
  connect,
  ApiResponse,
  Grid,
  PageCard,
  StudentCard,
  moment,
  Button,
  ApiCall,
} from 'omni-common-ui';

import { actions as Group } from 'containers/Group';
import { actions as reportActions, StudentReportSummary } from 'data/ProgressReports/StudentReportSummaries';
import { actions as approveActions } from 'data/ProgressReports/ApproveByDos';
import rejectActions from 'data/ProgressReports/RejectByDos';
import { actions as progressTestActions } from 'data/ProgressTests';
import studentReportCommentActions from 'data/ProgressReports/StudentReportComment';
import { GroupMember, actions as GroupMembers } from 'data/GroupMembers';
import ArrowLink from 'components/ArrowLink';
import ProgressReportStatus from 'components/ProgressReportStatus';
import AddInternalNoteControl from 'components/AddInternalNoteControl';
import UserCard from 'components/UserCard';
import StudentCardProfile from 'containers/StudentCardProfile';
import ExpansionButton from 'components/ExpansionButton';
import RejcetNotePopup from 'components/RejectNotePopup';

class DosApprovalCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: null,
      isEditingComment: false,
      // the publish button is disabled while publishing
      isPublishButtonDisabled: false,
      // when publish succeeds we don't fetch again - we simply update this.
      isReportStatusPublished: false,
      isSaveAllTriggered: false,  // mutex for the save all part
      isReportDetailsExpandedOnMobile: false,
      shouldShowRejectDialog: false,
    };
    this._hideShowRejectDialog = this._hideShowRejectDialog.bind(this);
    this._onExpansionButtonClicked = this._onExpansionButtonClicked.bind(this);
  }

  componentWillMount() {
    this.setState({
      comments: this.props.studentReport && this.props.studentReport.comments,
    });
  }

  componentWillReceiveProps({ studentReport, shouldTriggerSaveAllComments }) {
    const { progressReportId, studentId, submitStudentReportComment } = this.props;
    const { id: studentReportId } = studentReport;
    let comments = this.state.comments;
    if (this.props.studentReport !== studentReport) {
      this.setState({ comments: comments = studentReport && studentReport.comments });
    }
    if (shouldTriggerSaveAllComments &&
          this.state.isEditingComment &&
        ! this.state.isSaveAllTriggered) {
      this.setState({ isSaveAllTriggered: true });
      submitStudentReportComment(progressReportId, studentReportId, comments, studentId);
    }
    if (! shouldTriggerSaveAllComments) {
      this.setState({ isSaveAllTriggered: false });
    }
  }

  _onExpansionButtonClicked() {
    const { isReportDetailsExpandedOnMobile } = this.state;
    this.setState({
      isReportDetailsExpandedOnMobile: ! isReportDetailsExpandedOnMobile,
    });
  }

  _onEditButtonClicked() {
    this.setState({ isEditingComment: true });
    is.function(this.props.onEnterEditMode) && this.props.onEnterEditMode();
  }

  _onRejectButtonClicked() {
    this.setState({ shouldShowRejectDialog: true });
  }

  _rejectStudentReport(note) {
    const { progressReportId, studentReport, studentId, rejectStudentReport } = this.props;
    const studentReportId = studentReport.id;
    rejectStudentReport(note, progressReportId, studentReportId)
      .then(() => this.props.fetchStudentReportSummary(progressReportId, studentId));
  }

  _onCommentChanged(text) {
    this.setState({ comments: text });
    is.function(this.props.onCommentChanged) && this.props.onCommentChanged(text);
  }

  _onDiscardCommentClick() {
    const { studentReport } = this.props;
    this.setState({
      isEditingComment: false,
      comments: studentReport && studentReport.comments,
    });
    is.function(this.props.onLeaveEditMode) && this.props.onLeaveEditMode();
  }

  _onSaveCommentClicked(commentText) {
    const { progressReportId, studentReport, studentId, submitStudentReportComment } = this.props;
    const { id: studentReportId } = studentReport;
    submitStudentReportComment(progressReportId, studentReportId, commentText, studentId)
    .then(() =>
      this.props.fetchStudentReportSummary(progressReportId, studentId));
    this.setState({
      isEditingComment: false,
    });
    this.props.onLeaveEditMode && this.props.onLeaveEditMode();
  }

  _onPublishClicked() {
    const { progressReportId, studentReport, studentId, approveStudentReport } = this.props;
    const studentReportId = studentReport.id;
    if (is.not.string(progressReportId) || is.not.string(studentReportId)) {
      return;
    }
    this.setState({ isPublishButtonDisabled: true });
    approveStudentReport(progressReportId, studentReportId)
    .then((result) => {
      if (Error.isError(result.payload)) {
        this.setState({ isPublishButtonDisabled: false });
      } else {
        this.setState({ isReportStatusPublished: true });
        this.props.fetchStudentReportSummary(progressReportId, studentId);
      }
    })
    .then(() => {
      const { progressTestPlan, groupId } = this.props;
      if (! is.existy(progressTestPlan)) {
        return;
      }
      this.props.fetchProgressTest(groupId, progressTestPlan);
    });
  }

  _renderComments() {
    if (is.not.string(this.state.comments) ||
        is.empty(this.state.comments)) {
      return <div>This Progress Report does not include comments.</div>;
    }

    return <div>
      <p className={styles.DosApprovalCard_comments_body}>
        {this.state.comments}
      </p>
    </div>;
  }

  _renderCommentsEditor() {
    return <AddInternalNoteControl text={this.state.comments}
        maxCharacters={500}
        onChange={(text) => this._onCommentChanged(text)}
        onDiscardClick={() => this._onDiscardCommentClick()}
        onSaveClick={(text) => this._onSaveCommentClicked(text)} />;
  }

  _renderButtons() {
    return <Button.Container className={styles.DosApprovalCard_buttons}>
      {[
        this._renderPublishButton(),
        this._renderRejectButton(),
        this._renderEditButton(),
      ]}
    </Button.Container>;
  }

  _renderEditButton() {
    const { isReportStatusPublished } = this.state;
    return <Button key="edit-button"
        type={Button.Type.default}
        onClick={() => this._onEditButtonClicked()}
        disabled={isReportStatusPublished}>
      Edit
    </Button>;
  }

  _renderRejectButton() {
    return <Button key="reject-button"
        type={Button.Type.default}
        onClick={() => this._onRejectButtonClicked()}>
        Reject
      </Button>
   ;
  }

  _renderPublishButton() {
    const { isReportStatusPublished, isPublishButtonDisabled } = this.state;
    const buttonLabel = isReportStatusPublished ? 'Completed' : 'Approve';
    return <Button key="publish-button"
        onClick={() => this._onPublishClicked()}
        type={Button.Type.primary}
        disabled={isPublishButtonDisabled}>
      {buttonLabel}
    </Button>;
  }

  _renderRejectDialog() {
    return this.state.shouldShowRejectDialog && <RejcetNotePopup isOpen
        isLoading={this.props.isAnyApiCall}
        onSave={(note) => this._rejectStudentReport(note)}
        onCancel={this._hideShowRejectDialog} />;
  }

  _hideShowRejectDialog() {
    this.setState({ shouldShowRejectDialog: false });
  }

  render() {
    const {
      student,
      studentReport,
      progressTest,
      studentProgressTestResult,
      timeZone,
      buildRoute,
    } = this.props;

    const { isEditingComment, isReportStatusPublished } = this.state;

    if (is.undefined(studentReport)) {
      return null;
    }

    const progressTestSkills = progressTest.data.skills;
    const { totalScore } = studentProgressTestResult;
    const { percentage, skillScorePercentages } = totalScore;
    const { percentage: previousPercentage, skillScorePercentages: previousSkillScorePercentages } =
        studentProgressTestResult.previousTotalScore;

    // mimics the backend response string. do not alter
    const localReportStatus =
        isReportStatusPublished ? StudentReportSummary.Status.Completed : studentReport.status;
    const reportLink = `./group/${this.props.groupId}` +
      `/unit-report/${this.props.progressReportId}` +
      `/student/${student.studentGeneralInfo.id}`;

    return <PageCard className={styles.DosApprovalCard}>
      <Grid>
        <Grid.Group>
          <Grid.Item xs={12}
              sm={4}
              className={classnames(styles.DosApprovalCard_leftColumn, {
                [styles.__expandedOnMobile]: this.state.isReportDetailsExpandedOnMobile,
              })}>
            <StudentCard className={styles.DosApprovalCard_student}
                borderless
                backgroundless
                withSeparatorLine>
              <StudentCardProfile studentId={student.studentGeneralInfo.id}
                  status={student.status}
                  statusHighlighted={student.isInProduction} />
              <StudentCard.Content />
            </StudentCard>
            <div className={styles.DosApprovalCard_status}>
              <strong className={styles.DosApprovalCard_status_label}>
                Report<br />
                Status
              </strong>
              <ProgressReportStatus status={localReportStatus} />
            </div>
            <div className={styles.DosApprovalCard_scores}>
              <ul className={styles.DosApprovalCard_scores_breakdown}>
                <li className={styles.DosApprovalCard_scores_total}>
                  Total Score:&nbsp;
                  <span className={styles.DosApprovalCard_scores_percentage}>
                    {totalScore.isNotApplicable ? 'n/a' : `${percentage}%`}
                  </span>
                  {is.number(previousPercentage) && previousPercentage !== percentage ?
                    <span className={classnames(
                        styles.DosApprovalCard_scores_percentage,
                        styles.DosApprovalCard_scores_previous)}>
                      {previousPercentage}%
                    </span> : null}
                </li>
                {progressTestSkills.map((skill) =>
                  <li key={skill.skillId}>
                    {(() => {
                      const currentSkillScorePerc = skillScorePercentages.get(skill.skillId);
                      const previousSkillScorePerc =
                          previousSkillScorePercentages.get(skill.skillId);
                      const currentSkillScorePercText =
                          is.number(currentSkillScorePerc) ? `${currentSkillScorePerc}%` : '';
                      const output = [
                        <span key={`${student.studentGeneralInfo.id}-${skill.skillId}-perc`}
                            className={styles.DosApprovalCard_scores_percentage}>
                          {skill.name}: {currentSkillScorePercText}
                        </span>,
                      ];
                      if (is.number(previousSkillScorePerc) &&
                          previousSkillScorePerc !== currentSkillScorePerc) {
                        output.push(
                          <span key={`${student.studentGeneralInfo.id}-${skill.skillId}-prevPerc`}
                              className={classnames(
                                styles.DosApprovalCard_scores_percentage,
                                styles.DosApprovalCard_scores_previous)}>
                            {previousSkillScorePerc}%
                          </span>
                        );
                      }
                      return output;
                    })()}
                  </li>)}
              </ul>
              <ArrowLink className={styles.DosApprovalCard_reportLink}
                  to={buildRoute(reportLink)}>
                Report
              </ArrowLink>
            </div>
            <ExpansionButton className={styles.DosApprovalCard_expander}
                isExpand={this.state.isReportDetailsExpandedOnMobile}
                onExpansionButtonClick={this._onExpansionButtonClicked} />
          </Grid.Item>
          <Grid.Item xs={12}
              sm={8}
              className={styles.DosApprovalCard_rightColumn}> {/* SAFARI :( */}
            <div className={styles.DosApprovalCard_comment}>
              <UserCard id={studentReport.commentedByUserId}
                  className={styles.DosApprovalCard_teacher}
                  getLines={({ user }) => [
                    <div className={styles.DosApprovalCard_teacher_line}
                        key="UserCard#item0">
                      {user.firstName} {user.lastName}
                    </div>,
                    <div className={styles.DosApprovalCard_teacher_line}
                        key="UserCard#item1">
                      Teacher
                    </div>,
                    <div className={styles.DosApprovalCard_teacher_line}
                        key="UserCard#item2">
                      {moment
                        .utc(studentReport.commentedTimeUtc)
                        .clone()
                        .tz(timeZone)
                        .format('YYYY.MM.DD')}
                    </div>,
                  ]} />
              {isEditingComment ?
                this._renderCommentsEditor() :
                this._renderComments()}
            </div>
            {! isEditingComment && ! isReportStatusPublished ?
              this._renderButtons() : null}
          </Grid.Item>
        </Grid.Group>
      </Grid>
      {this._renderRejectDialog()}
    </PageCard>;
  }
}

DosApprovalCard.propTypes = {
  fetchStudentReportSummary: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
  timeZone: PropTypes.string.isRequired,
  approveStudentReport: PropTypes.func.isRequired,
  rejectStudentReport: PropTypes.func.isRequired,
  progressReportId: PropTypes.string.isRequired,
  studentId: PropTypes.string.isRequired,
  studentReport: PropTypes.object,
  progressTest: PropTypes.instanceOf(ApiResponse),
  studentProgressTestResult: PropTypes.object,
  submitStudentReportComment: PropTypes.func,
  student: PropTypes.instanceOf(GroupMember),
  approval: PropTypes.instanceOf(ApiResponse),
  location: PropTypes.object.isRequired,
  buildRoute: PropTypes.func.isRequired,
  shouldTriggerSaveAllComments: PropTypes.bool,
  onEnterEditMode: PropTypes.func.isRequired,
  onLeaveEditMode: PropTypes.func.isRequired,
  onCommentChanged: PropTypes.func,
  progressTestPlan: PropTypes.object,
  isAnyApiCall: PropTypes.boolean,
  fetchProgressTest: PropTypes.func.isRequired,
};

function mapStateToProps(state, ownProps) {
  const { progressReportId, studentId, groupId } = ownProps;
  const { timeZone } = Group.getCentre(state, groupId);

  const key = `${progressReportId}-${studentId}`;
  const studentReport = state.get('rootReducer')
      .get('studentReportSummaries')
      .get(`${progressReportId}`)
      .data
      .get(`${studentId}`);

  const approval = state.get('rootReducer')
      .get('approveByDos')
      .get(key);

  const progressReport = state.get('rootReducer')
      .get('groups')
      .get(groupId).data
      .get('progressReports').data
      .get(progressReportId);

  const student = GroupMembers.getMemberById(state, studentId);
  let progressTest = null;
  let studentProgressTestResult = null;
  let progressTestPlan = null;

  if (progressReport) {
    const { progressTestId: reportProgressTestId } = progressReport;
    progressTest = state.get('rootReducer')
      .get('progressTests')
      .get(reportProgressTestId);

    studentProgressTestResult =
        progressTest.data.studentProgressTestResults.get(studentId);

    progressTestPlan = state.get('rootReducer')
      .get('progressTestsPlan')
      .get(groupId)
      .data
      .find((plan) => plan.progressReportId === progressReportId);
  }
  return {
    timeZone,
    progressReportId,
    progressTest,
    studentReport,
    studentProgressTestResult,
    student,
    approval,
    progressTestPlan,
    groupId,
    isAnyApiCall: !! isAnyApiCall(state),
  };
}
function isAnyApiCall(state) {
  return !! (state.get('apiCalls') || new List())
    .filter((call, key) =>
      ['PUT', 'POST', 'GET'].some((method) => key.startsWith(method)))
    .find((call) => ApiCall.State.isLoading(call));
}

function mapDispatchToProps(dispatch) {
  return Object.assign({},
      bindActionCreators(reportActions, dispatch),
      bindActionCreators(rejectActions, dispatch),
      bindActionCreators(approveActions, dispatch),
      bindActionCreators(progressTestActions, dispatch),
      bindActionCreators(studentReportCommentActions, dispatch));
}

export default connect(mapStateToProps, mapDispatchToProps)(DosApprovalCard);



// WEBPACK FOOTER //
// ./containers/Group/ProgressReport/DosApprovalList/DosApprovalCard/index.jsx